module.exports = __webpack_public_path__ + "static/img/mgcm.319273b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mgcm.png
// module id = HTRT
// module chunks = 4